let breakpoints = {};

export default breakpoints;
